import styled from 'styled-components';

export const FlightSearchWrapper = styled.div`
  padding: 20px;
`;

export const StyledListingSearch = styled.div`
  display: grid;
  grid-template-columns: auto repeat(2, 260px) 120px;
  grid-template-rows: 78px;
  grid-gap: 20px;
  margin: 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
  }
`;

export const SpaceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1px;
  position: relative;
  background-color: rgba(41, 42, 44, 0.15);
`;

export const IconContainer = styled.div`
  width: 4;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const IconCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background-color: ${({ theme }) => theme.palette.white};
  border: solid 1px rgba(41, 42, 44, 0.15);
  cursor: pointer;
`;

export const ResponsiveFlightTripTypeSelect = styled.div`
  padding: 15px 0px;
`;

export const ChangeVerticalIconWrapper = styled.div`
  position: absolute;
  right: 0px;
  bottom: -21px;
  border: 1px solid rgba(75, 75, 75, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 10px;
  background-color: ${({ theme }) => theme.palette.white};
  & > span {
    display: flex;
  }
`;

export const StickyFlightSearchWrapper = styled.div<{
  sticky?: boolean;
}>`
  margin: 0 auto;
  ${({ sticky, theme }) => `
      margin-top: ${sticky ? '0' : ' 32px'};
      position: ${sticky ? 'fixed' : 'unset'};
      width: ${sticky ? '100vw' : 'fit-content'};
      background-color: ${sticky ? theme.palette.white : 'transparent'};
      `}

  ${({ sticky }) =>
    ` ${
      sticky
        ? `
  top: 0;
  transition: all 0.15s ease;
  animation: smoothScroll 0.15s forwards;
  z-index: 999;
  box-shadow: 3px 20px 19px 5px rgba(0,0,0,0.27);
  `
        : ''
    } `}
  display: flex;

  @keyframes smoothScroll {
    0% {
      transform: translateY(-142px);
    }

    100% {
      transform: translateY(0px);
    }
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const FlightSearchBarContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const SearchBarWrapper = styled.div`
  max-width: fit-content;

  & > div {
    max-width: 1240px;
    width: 1240px;
    grid-template-columns: repeat(3, 330px) 190px;
    padding: 10px 0;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    & > div {
      width: 100vw;
      grid-template-columns: 1fr;
      padding: 15px 20px;
    }
  }
`;
